import { questionsService } from '../service'

export const questions = {
  state: {
    items: [],
    total: 0,
    loading: false,
    currentQuestion: null
  },
  mutations: {
    SET_ITEMS (s, v) {
      s.items = v
    },
    SET_TOTAL (s, v) {
      s.total = v
    },
    SET_LOADING (s, v) {
      s.loading = v
    },
    SET_CURRENT_QUESTION (s, v) {
      s.currentQuestion = v
    },
    ADD_QUESTION (s, question) {
      s.items.push(question)
    },
    UPDATE_QUESTION (s, updatedQuestion) {
      const index = s.items.findIndex(q => q.id === updatedQuestion.id)
      if (index !== -1) {
        s.items.splice(index, 1, updatedQuestion)
      }
    },
    REMOVE_QUESTION (s, id) {
      s.items = s.items.filter(q => q.id !== id)
    },
    REMOVE_SELECTED_QUESTIONS (s, ids) {
      s.items = s.items.filter(q => !ids.includes(q.id))
    }
  },
  getters: {
  },
  actions: {
    getQuestions ({ commit }, params = {}) {
      commit('SET_LOADING', true)
      return questionsService.getQuestionList(params)
        .then((resp) => {
          commit('SET_ITEMS', resp.data.items)
          commit('SET_TOTAL', resp.data.total)
          commit('SET_LOADING', false)
          return resp.data
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          throw error
        })
    },

    exportQuestions (_ctx, { groupId = '' } = {}) {
      return questionsService.exportQuestions(groupId)
    },

    importQuestions (_ctx, { items } = {}) {
      return questionsService.importQuestions(items)
        .then(resp => resp.data)
    },

    getQuestionById ({ commit }, id) {
      return questionsService.getQuestionById(id)
        .then((resp) => {
          commit('SET_CURRENT_QUESTION', resp.data)
          return resp.data
        })
    },

    createQuestion ({ commit }, questionData) {
      return questionsService.createQuestion(questionData)
        .then((resp) => {
          commit('ADD_QUESTION', resp.data)
          return resp.data
        })
    },

    updateQuestion ({ commit }, { id, questionData }) {
      return questionsService.updateQuestion(id, questionData)
        .then((resp) => {
          commit('UPDATE_QUESTION', resp.data)
          return resp.data
        })
    },

    deleteQuestion ({ commit }, id) {
      return questionsService.deleteQuestion(id)
        .then(() => {
          commit('REMOVE_QUESTION', id)
          return id
        })
    },

    deleteSelectedQuestions ({ commit }, ids) {
      const deletePromises = ids.map(id => questionsService.deleteQuestion(id))

      return Promise.all(deletePromises)
        .then(() => {
          commit('REMOVE_SELECTED_QUESTIONS', ids)
          return ids
        })
    }
  },
  namespaced: true
}
